<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12">
        <h2 class="my-4">Time line chart</h2>
      </b-col>
    </b-row>

   <b-row>
      <b-col cols="12" lg="8" offset-lg="2">
        <h2 class="mb-4">Progreso del curso</h2>
        
        <VerticalTimeline :items="timelineItems" />
      </b-col>
    </b-row>
<hr>
<b-row>
      <b-col cols="12" lg="10" offset-lg="1">
        <h2 class="mb-4">Tu trayectoria educativa</h2>
        
        <VerticalTimeline 
          :items="educationPath"
          completedColor="#28a745"
          activeColor="#ff5e20"
          pendingColor="#ddd"
        />
      </b-col>
    </b-row>
<hr>
 <b-row>
      <b-col cols="12" lg="8" offset-lg="2">
        <h2 class="mb-4">Historial de Actividades</h2>
        
        <VerticalTimeline :items="activities">
          <!-- Slot personalizado para el item 0 -->
          <template #item-0>
            <b-button variant="primary" size="sm">
              Ver detalles
            </b-button>
          </template>

          <!-- Slot personalizado para el item 1 -->
          <template #item-1="{ item }">
            <div class="d-flex align-items-center mt-2">
              <b-progress :value="85" class="flex-grow-1 mr-2" />
              <small class="text-muted">85% {{ item }}</small>
            </div>
          </template>
        </VerticalTimeline>
      </b-col>
    </b-row>

  </b-container>
</template>

<script>
import VerticalTimeline from '@/components/Graficas/VerticalTimeline.vue'


export default {
  name: 'pocGraficaTimeLine',
  components: {
    VerticalTimeline
  },
  data() {
    return {

 activities: [
        {
          title: 'Curso Iniciado',
          description: 'Comenzaste el curso de Matemáticas Avanzadas',
          date: 'Hace 2 horas',
          completed: true
        },
        {
          title: 'Unidad 1 en Progreso',
          description: 'Estás viendo los videos de la primera unidad',
          date: 'Ahora',
          active: true
        },
        {
          title: 'Quiz Pendiente',
          description: 'Debes completar el quiz de la unidad 1',
          date: 'Próximo',
          completed: false
        }
      ],

 educationPath: [
        {
          title: 'Nivel Básico Completado',
          description: 'Has completado todos los cursos del nivel básico con excelentes calificaciones',
          date: 'Dic 2023',
          completed: true,
          icon: 'fas fa-graduation-cap',
          tags: [
            { label: 'Básico', color: '#28a745' },
            { label: '100%', color: '#17a2b8' }
          ]
        },
        {
          title: 'Nivel Intermedio Completado',
          description: 'Aprobaste todos los módulos del nivel intermedio',
          date: 'Ene 2024',
          completed: true,
          icon: 'fas fa-star',
          tags: [
            { label: 'Intermedio', color: '#ffc107' },
            { label: '95%', color: '#17a2b8' }
          ]
        },
        {
          title: 'Nivel Avanzado - En Curso',
          description: 'Estás cursando el nivel avanzado. Llevas 4 de 10 módulos completados',
          date: 'Feb 2024',
          active: true,
          icon: 'fas fa-rocket',
          tags: [
            { label: 'Avanzado', color: '#ff5e20' },
            { label: '40%', color: '#17a2b8' }
          ]
        },
        {
          title: 'Certificación Profesional',
          description: 'Obtén tu certificación profesional al completar todos los niveles',
          date: 'Mar 2024',
          completed: false,
          icon: 'fas fa-award',
          tags: [
            { label: 'Próximamente', color: '#6c757d' }
          ]
        },
        {
          title: 'Especialización',
          description: 'Accede a cursos de especialización avanzada',
          date: 'Abr 2024',
          completed: false,
          icon: 'fas fa-crown'
        }
      ],


      timelineItems: [
        {
          title: 'Introducción al Curso',
          date: '01/09/2024',
          description: 'Bienvenida y presentación del curso.',
          completed: true,
          tags: [
            { label: 'Completado', color: '#28a745' }
          ]
        },
        {
          title: 'Módulo 1: Fundamentos',
          date: '15/09/2024',
          description: 'Aprender los conceptos básicos.',
          active: true,
          tags: [
            { label: 'En Progreso', color: '#ffc107' }
          ]
        },
        {
          title: 'Módulo 2: Aplicaciones Prácticas',
          date: '30/09/2024',
          description: 'Aplicar lo aprendido en casos reales.',
          tags: [
            { label: 'Pendiente', color: '#6c757d' }
          ]
        },
        {
          title: 'Proyecto Final',
          date: '15/10/2024',
          description: 'Desarrollar un proyecto integrador.',
          tags: [
            { label: 'Pendiente', color: '#6c757d' }
          ]
        }
      ]




    }//return
  }
}
</script>